
const handleFetchError = (error) => {
    console.error('Fetch Error:', error);
    throw error;
}

const handleFetchResponse = (response) => {
    if (!response.ok) {
        console.error(`HTTP Error: ${response.status} ${response.statusText}`);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    switch (response.status) {
        case 200:
        case 201:
            return response.json().catch(error => {
                console.error('JSON Parse Error:', error);
                return { dealersDetailList: [], total: 0 };
            });
        default:
            return { dealersDetailList: [], total: 0 };
    }
}

export const objToQueryString = (obj: any, excludeNull = true) => {
    return Object.keys(obj)
        ?.filter(key => excludeNull ? !!obj?.[key] : true)
        ?.map((key: string) => `${key}=${obj?.[key]}`)
        ?.join('&')
}

export { handleFetchError, handleFetchResponse };